import { ClickBubble, ClickBubbleDefs } from './assemblyDetail'
import { FingerBehind, GripperFront, GripRods } from './assemblyGripper'
import { Axis, ClickTicks, Hooks, Nest, ProbeBody, ProbeMover, ShuttleRail } from './assemblyParts'
import { AirService, Cabinet, Carriage, CFrame, CropMarks, DragChain, Floor, Table, XAxis } from './kit'
import { Cap, Fixture, PadPartDefs } from './padParts'
import { face } from './projection'

/* ==========================================================================
   The assembly film: the printed cap from the pad film's fixture is picked,
   carried and aligned on one axis over its housing, pressed in — the snap
   hooks ride the chamfer and click into the undercut windows, seen in
   section — then the nest shuttles the part under a spring-loaded probe,
   the check prints and the part goes into register.
   ========================================================================== */

const REG_LEADER = 'M1371 487L1392 466H1540'
/* The supply fixture is the pad film's part fixture, moved onto the cliché's spot. */
const SUPPLY = 'translate(-640 0)'

function AssemblyDefs({ id }) {
  return (
    <defs>
      <PadPartDefs id={id} left={false} right />
      <pattern id={`${id}hatch`} patternUnits="userSpaceOnUse" width="5" height="5" patternTransform="rotate(45)">
        <path className="pp-hatch" d="M2.5 0V5" />
      </pattern>
      <clipPath id={`${id}hooks`} clipPathUnits="userSpaceOnUse">
        <path d="M-1100 -300H2700V1200H-1100ZM340 627V900H620V627Z" clipRule="evenodd" />
      </clipPath>
      <ClickBubbleDefs id={id} />
    </defs>
  )
}

function Supply() {
  return (
    <g transform={SUPPLY}>
      <Fixture />
      <path className="f-aF pp-cap-shadow" d="M1055.6 628H1195.6L1217.2 568H1077.2Z" />
    </g>
  )
}

function Register() {
  return (
    <g className="pp-register">
      <CropMarks transform={face(1274, 528)} scale={1.64} />
      <g className="pp-reg-leader">
        <path className="l-knock" d={REG_LEADER} />
        <path className="l-signal" d={REG_LEADER} />
      </g>
      <circle className="f-live pp-reg-dot" cx="1371" cy="487" r="3.5" />
    </g>
  )
}

/** The machine, back to front. */
function Machine({ id }) {
  return (
    <>
      <Floor />
      <Cabinet />
      <Table />
      <ProbeBody />
      <CFrame />
      <AirService />
      <DragChain />
      <XAxis />
      <Supply />
      <ShuttleRail />
      <Nest id={id} />
      <GripRods />
      <Carriage />
      <FingerBehind />
      <Hooks id={id} />
      <g className="pp-cap-carry">
        <Cap id={id} shadow={false} />
      </g>
      <GripperFront />
      <ProbeMover />
      <ClickTicks />
      <Axis />
      <ClickBubble id={id} />
      <Register />
    </>
  )
}

export function AssemblyStage({ id }) {
  return (
    <>
      <AssemblyDefs id={id} />
      <g className="pp-cam">
        <Machine id={id} />
      </g>
    </>
  )
}
